<template>
  <div class="container">
    <headerWX class="headerWX"></headerWX>
    <div style="height: 50px; width: 1px"></div>

    <div class="Content">
      <!-- 标头 -->
      <div class="C-Header">
        <div class="Header-tit">
          <img src="@/assets/imgs/FormATeam/tit1.png" alt="" />
          <img src="@/assets/imgs/FormATeam/tit2.png" alt="" />
        </div>
        <div class="ExplanationBtn">
          <img
            src="@/assets/imgs/FormATeam/rule.png"
            @click="openDialog(3)"
            alt="规则说明"
          />
        </div>
      </div>
      <!-- 选择创建 还是 加入 -->
      <div class="Choice" v-if="totalData.inTeam == false">
        <img
          @click="openDialog(1)"
          src="@/assets/imgs/FormATeam/FormTeam.png"
          alt="创建队伍"
        />
        <img
          @click="openDialog(2)"
          src="@/assets/imgs/FormATeam/JoinTeam.png"
          alt="加入队伍"
        />
      </div>

      <!-- 入队body -->
      <div class="ConsumptionBody" v-else>
        <div class="textTit">
          <p>
            入队码：<span>{{ totalData.teamInfo?.joinCode }}</span>
          </p>
          <p>
            队伍名称：<span>{{ totalData.teamInfo?.teamName }}</span>
          </p>
          <div class="goConsumption">
            <img src="@/assets/imgs/FormATeam/goConsumption.png" alt="" @click="goRecharge"/>
          </div>
        </div>
        <div class="items">
          <div class="item" v-for="value in 10" :key="value">
            <div class="i" v-if="totalData.teamInfo?.members[value - 1]">
              <p :title="totalData.teamInfo.members[value - 1].username">
                玩家名称：{{ totalData.teamInfo.members[value - 1].username }}
              </p>
              <p>
                贡献积分：{{
                  totalData.teamInfo.members[value - 1].personalPoints
                }}
              </p>
            </div>
            <div class="i" v-else>
              <p>玩家名称：暂无</p>
              <p>贡献积分：暂无</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 组队消费奖励 -->
      <div class="ConsumptionRewards">
        <div class="CR-Header">
          <img src="@/assets/imgs/FormATeam/tit3.png" alt="" />
        </div>

        <!-- 奖励 -->
        <div class="RewardBody">
          <div class="items" v-for="value in 3" :key="value">
            <div class="RewardImg">
              <el-tooltip
                class="item"
                effect="dark"
                :content="totalData.tiers[value - 1].itemDesc"
                placement="top"
              >
                <img :src="totalData.tiers[value - 1].itemImg" alt="" />
              </el-tooltip>
              <p style="padding: 10px 0">
                {{ totalData?.tiers[value - 1].itemName }}
              </p>
              <p>需贡献积分：{{ totalData?.tiers[value - 1].tierPoints }}</p>
            </div>

            <div class="RewardBodyBtn">
              <img
                v-if="(totalData?.tiers[value - 1].reached) == false"
                src="@/assets/imgs/FormATeam/component/RewardBodyBtn0.png"
                alt="未领取"
              />
              <img
                v-else-if="
                  (totalData?.tiers[value - 1].claimed) == false &&
                  (totalData?.tiers[value - 1].reached) == true
                "
                src="@/assets/imgs/FormATeam/component/RewardBodyBtn1.png"
                alt="领取"
                @click="claimReward(totalData.tiers[value - 1])"
              />
              <img
                v-else-if="
                  (totalData.tiers[value - 1].claimed) == true
                "
                src="@/assets/imgs/FormATeam/component/RewardBodyBtn2.png"
                alt="已领取"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 80px; width: 1px"></div>

    <!-- 弹窗 -->
    <div class="dialog" v-if="istoolTipBox" @click="cancel">
      <popUp :close="cancel" :Confirm="Confirm" :type="type"></popUp>
      <!-- <el-button @click="istoolTipBox = false">取 消</el-button> -->
      <!-- <el-button type="primary" @click="istoolTipBox = false">确 定</el-button> -->
    </div>
  </div>
</template>

<script>
import headerWX from "./component/header.vue";
import popUp from "./component/index.vue";
import Cookies from "js-cookie";

import {
  getInfoApi,
  createTeamApi,
  joinTeamApi,
  claimRewardApi,
} from "@/api/FormATeam";
import { getMemberInfoApi } from "@/api/public.js";
export default {
  name: "FormATeam",
  components: {
    headerWX,
    popUp,
  },
  data() {
    return {
      // 弹窗控制  fslse true
      istoolTipBox: false,
      //弹窗类型
      type: 1,
      //用户信息
      userInfo: {},
      totalData: [],
    };
  },
  created() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
      ? JSON.parse(localStorage.getItem("userInfo"))
      : "";

    this.init();
    this.getMemberInfo();
  },
  methods: {
    //去充值
    goRecharge(){
        window.open('http://shop.818long.com/#/shop')
    },
    // 打开弹窗
    openDialog(type) {
      this.istoolTipBox = true;
      this.type = type;
    },
    // 关闭弹窗cancel
    cancel() {
      this.istoolTipBox = false;
    },
    // 弹窗确认
    Confirm(data) {
      this.istoolTipBox = false;
      if (data.type == "Create") {
        this.createFun(data.TeamName);
      } else if (data.type == "Join") {
        this.JoinFun(data.TeamName);
      }
    },
    //创建队伍
    async createFun(teamName) {
      await createTeamApi({
        activityName: "2026teamup_activity",
        userId: Cookies.get("cwsl_userId"), // userId
        platForm: "web",
        teamName: teamName,
      })
        .then(({ data }) => {
          if (data.state == 200) {
            this.$message.success(data.message);
            this.init();
          } else {
            this.$message.error(data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    //  加入队伍
    async JoinFun(joinCode) {
      await joinTeamApi({
        activityName: "2026teamup_activity",
        userId: Cookies.get("cwsl_userId"), // userId
        platForm: "web",
        joinCode: joinCode,
      })
        .then(({ data }) => {
          if (data.state == 200) {
            this.$message.success(data.message);
            this.init();
          } else {
            this.$message.error(data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    // 领取奖励
    async claimReward(d) {
      await claimRewardApi({
        activityName: "2026teamup_activity",
        userId: Cookies.get("cwsl_userId"), // userId
        platForm: "web",
        tierPoints: d.tierPoints,
      })
        .then(({ data }) => {
          if (data.state == 200) {
            this.$message.success(data.data.message);
            this.init();
          } else {
            this.$message.error(data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    //获取 user信息
    async getMemberInfo() {
      await getMemberInfoApi({
        userId: Cookies.get("cwsl_userId"), // userId
        platForm: "web",
      })
        .then((res) => {
          if (res.data.state == 200) {
            this.userInfo = res.data.data;
            this.resetSetItem("userInfo", JSON.stringify(res.data.data));
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    }, // 获取用户信息
    // 初始化
    async init() {
      await getInfoApi({
        activityName: "2026teamup_activity",
        userId: Cookies.get("cwsl_userId"), // userId
        platForm: "web",
      }).then(({ data }) => {
        if (data.state == 200) {
          this.totalData = data.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  min-width: 1200px;
  max-width: 2000px;
  position: relative;
  margin: auto;
  background-image: url("../../assets/imgs/FormATeam/bg.png");
  background-size: 100% 100%;

  .Content {
    width: 80%;
    padding: 20px 0 50px 0;
    margin: auto;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(3px) saturate(150%);
    -webkit-backdrop-filter: blur(3px) saturate(150%);
    border-radius: 20px;

    .C-Header {
      width: 100%;
      position: relative;

      .Header-tit {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .ExplanationBtn {
        position: absolute;
        right: 30px;
        top: 0px;
        max-width: 100px;

        > img {
          width: 100%;
          cursor: pointer;
        }
      }
    }

    // 选择创建 还是 加入
    .Choice {
      width: 50%;
      margin: 20px auto;
      display: flex;
      justify-content: space-around;
      align-items: center;

      > img {
        cursor: pointer;
        /* 初始位置：基准值，和hover状态形成明确对比 */
        transform: translateY(0);
        /* 加长过渡时间到0.5秒，让上移更缓慢、平稳 */
        transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
      }

      > img:hover {
        transform: translateY(-5px);
      }
    }

    //入队body
    .ConsumptionBody {
      width: 70%;
      margin: 30px auto;

      .textTit {
        display: flex;
        gap: 20px;
        justify-content: center;
        position: relative;

        > p {
          font-size: 20px;
          font-weight: 700;

          > span {
            border-bottom: 2px solid #000000;
            padding: 0 10px;
            width: 180px;
            display: inline-block;
            font-size: 20px;
          }
        }

        .goConsumption {
          position: absolute;
          right: -50px;
          bottom: 0;
          cursor: pointer;
        }
      }

      .items {
        width: 100%;
        gap: 20px;
        grid-template-columns: repeat(5, 1fr);
        display: grid;
        margin-top: 50px;

        .item {
          height: 80px;
          background-color: #ffffff96;
          border-radius: 20px;
          backdrop-filter: blur(10px);

          .i {
            height: 100%;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-direction: column;
            justify-content: center;
          }

          p {
            width: 95%;
            overflow: hidden;
            /* 隐藏超出内容 */
            text-overflow: ellipsis;
            /* 显示省略号 */
            white-space: nowrap;
            /* 禁止换行 */
            font-weight: 700;
            user-select: none;
            color: #a2763a;
          }
        }
      }
    }

    // 组队消费奖励
    .ConsumptionRewards {
      .CR-Header {
        width: 30%;
        margin: auto;
        margin-bottom: 10px;
        text-align: center;
      }

      // 奖励
      .RewardBody {
        width: 80%;
        margin: auto;
        display: flex;
        justify-content: space-around;

        .items {
          width: 200px;
          height: 300px;
          background: #fff;
          /* 纯白色背景 */
          border-radius: 20px;
          border: 9px solid #ffffff9a;
          /* 半透明白色边框 */
          /* 核心修复：背景只裁剪到内边距区域，不覆盖边框 */
          background-clip: padding-box;
          /* 可选：如果需要圆角和边框完美贴合，补充以下属性 */
          box-sizing: border-box;
          /* 让宽高包含边框，避免元素整体变大 */
          position: relative;
          .RewardImg {
            position: absolute;
            top: 10%;
            width: 100%;
            text-align: center;
            > img {
              width: 60%;
            }
            p {
              width: 100%;
              overflow: hidden; /* 隐藏超出内容 */
              text-overflow: ellipsis; /* 显示省略号 */
              white-space: nowrap; /* 禁止换行 */
            }
          }

          .RewardBodyBtn {
            width: 100%;
            position: absolute;
            bottom: 20px;
            text-align: center;
          }
        }
      }
    }
  }

  .dialog {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
  }

  .headerWX {
    width: 100%;
  }
}
</style>
